/**
	 * 紐付設定画面のデータを取得するために使用するVO
	 */
export class GetRelatedDataModel {

  /**
   * 処理区分
   */
  public processDiv: string = <string>'';

  /**
   * 受注コード
   */
  public orderCode: string = <string>'';

  /**
   * 代表商品コード
   */
  public mainPCode: string = <string>'';
}
